import { Autocomplete, TextField } from '@mui/material'
import { empresas } from 'service/api'
import { useStore } from 'store'
import { SelectProps } from './types'

interface IProps extends SelectProps {
    children?: never
}

export function SelectEmpresa({
    size = 'small',
    variant = 'filled',
    width = 260,
    helperText,
    disabled,
    hideWhenSingle = false,
}: IProps) {
    const [companyId, setEmpresaId] = useStore(state => [
        state.companyId,
        state.setCompanyId,
    ])
    const { data = [], isFetched } = empresas.useFetch({
        refetchOnWindowFocus: false,
    })

    if (hideWhenSingle && data.length <= 1 && isFetched) {
        return null
    }

    const selectedEmpresa = data.find(e => e.id === companyId) || null

    return (
        <Autocomplete
            style={{ width }}
            options={data.sort((a, b) =>
                a.nomeFantasia.localeCompare(b.nomeFantasia),
            )}
            getOptionLabel={option => option?.nomeFantasia || ''}
            value={selectedEmpresa}
            onChange={(_, value) => {
                if (value) {
                    setEmpresaId(value.id)
                    useStore.setState({ company: value })
                }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={disabled}
            renderInput={params => (
                <TextField
                    {...params}
                    label="Empresa"
                    size={size}
                    variant={variant}
                    helperText={helperText}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Selecione uma empresa"
                    className="truncate"
                />
            )}
            noOptionsText={
                <span className="text-gray-500 select-none">
                    Nenhuma empresa
                </span>
            }
            clearIcon={null}
        />
    )
}
